import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { OrgCustomersActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const getOrgCustomer = (orgCustomerId): any => action(types.GET_ORG_CUSTOMER_REQUESTED, orgCustomerId);

export const getAllOrgCustomers = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ORG_CUSTOMERS_REQUESTED, { pagination, compile });

export const selectOrgCustomer = (orgCustomerId): any => action(types.SELECT_ORG_CUSTOMER_REQUESTED, {
  currentOrgCustomerId: orgCustomerId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  getOrgCustomerPending: (): any => action(types.GET_ORG_CUSTOMER_PENDING, {}),
  getOrgCustomerSuccess: (response): any => action(types.GET_ORG_CUSTOMER_SUCCESS, {
    orgCustomersById: response.entities.orgCustomers,
    currentOrgCustomerId: response.result,
  }),
  getOrgCustomerFailed: (error): any => action(types.GET_ORG_CUSTOMER_FAIL, { backendErrors: error }),
  getAllOrgCustomersPending: (pagination): any => action(types.GET_ALL_ORG_CUSTOMERS_PENDING, { pagination }),
  getAllOrgCustomersSuccess: (response, meta): any => action(types.GET_ALL_ORG_CUSTOMERS_SUCCESS, {
    orgCustomersById: response.entities.orgCustomers,
    orgCustomerIds: response.result,
    meta,
  }),
  getAllOrgCustomersFailed: (error): any => action(types.GET_ALL_ORG_CUSTOMERS_FAIL, { backendErrors: error }),
};

export default {
  getOrgCustomer,
  getAllOrgCustomers,
  selectOrgCustomer,
};
